import {getScenicArea, getDeviceByScenicAreaId, putScenicArea, postScenicArea, getRoleToScenicArea, deleteScenicArea } from '../../../api/eastCoastDataApi/scenicAreaApi'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'

const state = {
    allscenicArea:[],
    scenicArea: [],
    scenicAreaDevice: [],
    myRoleIds: [],
    myRoleToScenicAreaId: []
}

const getters = {
  getAllScenicArea: state => {
    return state.allscenicArea
  },

  getScenicArea: state =>(id) => {
    return state.allscenicArea.filter(s => s.id === id)
  },

  getMyScenicArea: state => {
    const targetScenicArea = []
    state.myRoleToScenicAreaId.forEach(id => {
      const sc = state.allscenicArea.find(sc => sc.id === id)
      if(!Utils.isEmptyObject(sc)) {
        targetScenicArea.push(sc)
      }
    })

    targetScenicArea.sort((a, b) => {
      return a.areasSort - b.areasSort < 0 ? -1 : 1
    })
    return targetScenicArea
  },

  getScenicAreaDevice: (state) => (deviceType = '') => {
    if(Utils.isEmptyObject(deviceType)) {
        return state.scenicAreaDevice
    }  

    if(Utils.isEmptyObject(state.scenicAreaDevice)){
      return []
    }

    return state.scenicAreaDevice.filter(device => {
        return device.operationType === deviceType
    })   
  },

  getWetherScienicArea: state => {
    return state.allscenicArea.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.WEATHER_INFO))
  }
}

const actions = {
  async getScenicArea({ commit }, condition) {
      commit('scenicAreaData', await getScenicArea(condition))
  },

  async getDeviceByScenicAreaId({ commit }, condition) {
    const data = await getDeviceByScenicAreaId(condition)
    commit('scenicAreaDevice', data)
    return data
  },

  async putScenicArea({ commit }, scenicArea) {
    const result = await putScenicArea(scenicArea)
    if (result.success) {
      commit('updateScenicArea', { data: result.data, mode: 'put' })
    }

    return result
  },

  async postScenicArea({commit}, scenicArea) {
    const result = await postScenicArea(scenicArea)
    if (result.success) {
      commit('updateScenicArea', { data: result.data, mode: 'post' })
    }

    return result
  },

  async deleteScenicArea({commit}, scenicArea) {
    const result = await deleteScenicArea(scenicArea)
    if (result.success) {
      commit('updateScenicArea', { data: scenicArea, mode: 'delete' })
    }

    return result
  },

  setRoleIds({commit}, roleIds) {
    commit('myRoleids', roleIds)
  },

  async getMyRoleToScenicArea({commit, state,  rootState }) {
    const allRoleScenicArea = rootState.eastCoastDataApi.roleToScenicArea.allRoleScenicArea
    const myScenicAreaList = allRoleScenicArea.filter(sc => state.myRoleIds.includes(sc.roleId))
    await commit('myRoleToScenicArea', myScenicAreaList)
  }
    
}

const mutations = {
  scenicAreaData(state, data) {
    if(Utils.isEmptyObject(data) || Utils.isEmptyObject(data.scenicAreaData)) {
      return 
    }

    if(data.id < 0) {
      state.allscenicArea = data.scenicAreaData
      state.scenicArea = data.scenicAreaData  
    } else {
        const index = state.scenicArea.findIndex(area => area.id === data.id)
        if(index < 0) {
            state.scenicArea.push(data.scenicAreaData)
        } else {
            state.scenicArea[index] = data.scenicAreaData
        }
    }
    
  },

  myRoleids(state, roleIds) {
    if(!Array.isArray(roleIds)) {
      return
    }

    state.myRoleIds = roleIds
  },

  myRoleToScenicArea(state, myScenicAreaList) {
    if(Utils.isEmptyObject(myScenicAreaList)) {
      return
    }

    const myScienicAreaIds = myScenicAreaList.map(e => e.scenicAreaIds).flat() // 一個帳號如果有兩個角色，將兩個array的scenicAreaID轉成一個array
    state.myRoleToScenicAreaId = new Set(myScienicAreaIds) // 移除重複元素
  },

  scenicAreaDevice(state, data) {
    if(Utils.isEmptyObject(data)) {
      state.scenicAreaDevice = [] 
    }

    state.scenicAreaDevice = data
  },

  updateScenicArea(state, { data, mode }) {
    switch (mode) {
      case 'post':
        state.allscenicArea.push(data)
        break
      
      case 'put':
        let targetIndex  = state.allscenicArea.findIndex(d => d.id === data.id)
        if (targetIndex !== -1) {
          //要回傳新的 array 元素才會觸發 state 更新 
          // state.allscenicArea[targetIndex] = data;
          state.allscenicArea.splice(targetIndex, 1, data); 
          
        } 
        break
  
      case 'delete' :
        state.allscenicArea = state.allscenicArea.filter(d => d.id !== data.id)
        break    
    }

    if(!Utils.isEmptyObject(state.allscenicArea)){
      state.allscenicArea.sort((a, b) => {
        return a.areasSort - b.areasSort < 0 ? -1 : 1
      })
    }
  }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }